import Vue from 'vue'
import Router from 'vue-router'
import header from '@/components/common/header'
import left from '@/components/common/left'
import login from '@/components/login'
import index from '@/components/index'
import register from '@/components/register'
import chujia from '@/components/chujia'
import order from '@/components/order'

import addCailiao from '@/components/addCailiao'
import luji from '@/components/luji'
import addLuji from '@/components/addLuji'
// import jianceCailiao from '@/components/jianceCailiao'
// import jianceLuji from '@/components/jianceLuji'
import renwu from '@/components/renwu'
import danwei from '@/components/danwei'
import xiangmu from '@/components/xiangmu'
import yiju from '@/components/yiju'
import orderCailiao from '@/components/orderCailiao'
import orderLuji from '@/components/orderLuji'
import orderJiance from '@/components/orderJiance'
import reportTemplate from '@/components/reportTemplate'
import reportFile from '@/components/reportFile'
import huikuan from '@/components/huikuan'
import yingshou from '@/components/yingshou'
import hkaccount from '@/components/hkaccount'
import demo from '@/components/demo'

Vue.use(Router)

// 获取原型对象push函数
const originalPush = Router.prototype.push

// 获取原型对象replace函数
const originalReplace = Router.prototype.replace

// 修改原型对象中的push函数
Router.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/header',
      name: 'header',
      component: header
    },
    {
      path: '/left',
      name: 'left',
      component: left
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/chujia',
      name: 'chujia',
      component: chujia
    },
    {
      path: '/order',
      name: 'order',
      component: order
    },


    {
      path: '/addCailiao',
      name: 'addCailiao',
      component: addCailiao
    },
    {
      path: '/luji',
      name: 'luji',
      component: luji
    },
    {
      path: '/addLuji',
      name: 'addLuji',
      component: addLuji
    },
    {
      path: '/renwu',
      name: 'renwu',
      component: renwu
    },
    // {
    //   path: '/jianceCailiao',
    //   name: 'jianceCailiao',
    //   component: jianceCailiao
    // },
    // {
    //   path: '/jianceLuji',
    //   name: 'jianceLuji',
    //   component: jianceLuji
    // },
    {
      path: '/danwei',
      name: 'danwei',
      component: danwei
    },
    {
      path: '/xiangmu',
      name: 'xiangmu',
      component: xiangmu
    },
    {
      path: '/yiju',
      name: 'yiju',
      component: yiju
    },
    {
      path: '/orderCailiao',
      name: 'orderCailiao',
      component: orderCailiao
    },
    {
      path: '/orderLuji',
      name: 'orderLuji',
      component: orderLuji
    },
    {
      path: '/orderJiance',
      name: 'orderJiance',
      component: orderJiance
    },
    {
      path: '/reportTemplate',
      name: 'reportTemplate',
      component: reportTemplate
    },
    {
      path: '/reportFile',
      name: 'reportFile',
      component: reportFile
    },
    {
      path: '/huikuan',
      name: 'huikuan',
      component: huikuan
    },
    {
      path: '/yingshou',
      name: 'yingshou',
      component: yingshou
    },
    {
      path: '/hkaccount',
      name: 'hkaccount',
      component: hkaccount
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   // ...  
//   if (to.path === '/login') { // 如果是登录页面路径，就直接next()
//     // console.log('555')
//     localStorage.removeItem("token");
//     localStorage.removeItem("username");
//     next()
//   }
//   var token = localStorage.getItem('token') // 获取用户登录token
//   console.log('token',token)
//   if(!token&&to.path!='/login'){
//     next('/login')
//   } else {
//     next();
//   }
  
// })
export default router


// WEBPACK FOOTER //
// ./src/router/index.js